import React from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Box,
  Stack,
  Divider,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import Paragraph from "./Paragraph";
import MButtonModal from "./ButtonModal";
import "@fontsource/playfair-display";
import ChairAltOutlinedIcon from "@mui/icons-material/ChairAltOutlined";
import IconPrice from "@mui/icons-material/AttachMoney"; // esempio di icona, puoi sostituirla con quelle che usi
import IconDefault from "@mui/icons-material/Help";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  Home,
  Elevator,
  LocationOn,
  Kitchen,
  Bed,
  Bathtub,
  Apartment,
  SquareFoot,
  Title,
  Style,
  Balcony,
  AcUnit,
  Details,
  Fireplace,
  RoomOutlined,
  Deck,
  AccountBalance,
} from "@mui/icons-material"; // Import delle icone da MUI
import googlemaps from "../../assets/picsAppartamenti/googlemaps.png";
import CarouselRooms from "../../components/UI/Carousel/CarouselRooms";
import Contact from "../ContactFooter/Contact";
import useAllPropertiesData from "../../utils/hooks/usePropertyData";
import usePropertyPlan from "../../utils/hooks/usePropertyPlan";

// Dati per la tabella delle caratteristiche

const RoomSingle = () => {
  const isMobile = useMediaQuery("(max-width: 1024px)");

  const { id } = useParams(); // Ottiene il parametro id dall'URL
  console.log(id);
  const { propertiesData, loading } = useAllPropertiesData(id);
  console.log(propertiesData);
  const { planimetriaData } = usePropertyPlan(id, "planimetria");
  const { planimetriaData: videoData } = usePropertyPlan(id, "video");

  // Aggiungi un controllo per verificare che i dati siano disponibili prima di usarli
  const document = propertiesData?.[0]; // Usa un optional chaining (?.) per evitare errori se `propertiesData` è undefined
  const planimetria = planimetriaData?.[0]; // Lo stesso controllo per `planimetriaData`
  const video = videoData?.[0]; // E per `videoData`
  console.log(document);
  if (!document || !planimetria || !video) {
    return (
      <Box height={"100vh"}>
        {" "}
        <Typography>Loading...</Typography>
      </Box>
    );
  }
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  const keyMappings = {
    pianiEdificio: "Piani Edificio",
    speseCondominio: "Spese di condominio",
    classeEnergetica: "Classe Energetica",
  };
  const getIconForKey = (key) => {
    switch (key) {
      case "prezzo":
        return <IconPrice fontSize="12px" />;
      case "camere":
        return <Bed fontSize="12px" />;
      case "bagni":
        return <Bathtub fontSize="12px" />;
      case "descrizione":
        return <IconDefault fontSize="12px" />;
      case "features":
        return <Apartment fontSize="12px" />;
      case "terrazzo":
        return <Deck fontSize="12px" />;
      case "grandezza":
        return <SquareFoot fontSize="12px" />;
      case "indirizzo":
        return <LocationOn fontSize="12px" />;
      case "piano":
        return <RoomOutlined fontSize="12px" />;
      case "ascensore":
        return <Elevator fontSize="12px" />;
      case "contratto":
        return <Home fontSize="12px" />;
      case "titolo":
        return <Title fontSize="12px" />;
      case "arredato":
        return <ChairAltOutlinedIcon fontSize="12px" />;
      case "balcone":
        return <Balcony fontSize="12px" />;
      case "climatizzazione":
        return <AcUnit fontSize="12px" />;
      case "cucina":
        return <Kitchen fontSize="12px" />;
      case "dettagli":
        return <Details fontSize="12px" />;
      case "locali":
        return <Apartment fontSize="12px" />;
      case "classeEnergetica":
        return <Apartment fontSize="12px" />;
      case "condizioni":
        return <Apartment fontSize="12px" />;
      case "pianiEdificio":
        return <RoomOutlined fontSize="12px" />;
      case "speseCondominio":
        return <AccountBalance fontSize="12px" />;
      case "riscaldamento":
        return <Fireplace fontSize="12px" />;
      default:
        return <IconDefault fontSize="12px" />;
    }
  };

  if (loading) {
    // Mostra un CircularProgress mentre i dati sono in fase di caricamento
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="90vh"
      >
        <Box
          width="100px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress
            size={40}
            sx={{
              color: "#0c6b8b",
            }}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box width={"100%"}>
      <Stack
        width={"100%"}
        marginTop={isMobile ? "100px" : undefined}
        flexDirection={isMobile ? "column" : "row"}
        p={3}
      >
        <Box width={isMobile ? "100%" : "70%"}>
          <Box sx={{ height: "30px", display: isMobile ? "none" : "block" }} />
          <Box width={"100%"}>
            <Box height={isMobile ? undefined : "60vh"}>
              <CarouselRooms property={document?.photos} />
            </Box>

            <Stack
              flexDirection={"row"}
              width={"100%"}
              sx={{
                height: "100%",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                padding: "2% 2%",
              }}
              justifyItems={"space-between"}
            >
              <Box
                display={isMobile ? "none" : "block"}
                width={"10%"}
                marginRight={"15px"}
                height={"50%"}
              >
                <a
                  href={`https://www.google.com/maps?q=${encodeURIComponent(
                    document?.indirizzo
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    onMouseEnter={(e) =>
                      (e.target.style.transform = "scale(1.05)")
                    } // Aumenta leggermente la dimensione
                    onMouseLeave={(e) =>
                      (e.target.style.transform = "scale(1)")
                    } // Ritorna alla dimensione originale
                    src={googlemaps}
                    alt="Mappa"
                    style={{
                      width: "100%",
                      transition: "transform 0.3s ease",
                      height: "100%",
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                  />
                </a>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: isMobile ? "100%" : "70%",
                }}
              >
                <Typography
                  fontSize={isMobile ? "18px" : undefined}
                  variant={isMobile ? "h6" : "h5"}
                >
                  {document?.titolo}
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Typography
                    variant={isMobile ? "body1" : "h6"}
                    color="textSecondary"
                  >
                    {document?.indirizzo}
                  </Typography>
                </Stack>
                <Stack flexDirection={"row"}>
                  <Typography
                    variant="h6"
                    color="#222222"
                    mt={1}
                    fontSize={isMobile ? "15px" : undefined}
                    display="flex"
                    gap={2}
                    flexWrap="wrap"
                    alignItems="center"
                  >
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Apartment fontSize="small" /> 4 camere
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <SquareFoot fontSize="small" /> 120 m²
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Bathtub fontSize="small" /> 2 bagni
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <Apartment fontSize="small" /> Piano 4
                    </Box>
                  </Typography>
                </Stack>
              </Box>
              <Box
                display={isMobile ? "none" : "block"}
                width={"20%"}
                justifyItems={"end"}
              >
                <Typography fontSize={28} variant="h5" fontFamily={"degular"}>
                  {document?.prezzo} Euro
                </Typography>
              </Box>
            </Stack>
            <Box
              display={isMobile ? "flex" : "none"}
              width={"100%"}
              justifyContent={"space-between"}
              alignItems={"center"}
              sx={{
                height: "100%",
                backgroundColor: "#f5f5f5",
                borderRadius: "8px",
                padding: "2% 2%",
              }}
            >
              <Box
                width={isMobile ? "10%" : "10%"}
                marginRight={"15px"}
                height={"50%"}
              >
                <a
                  href={`https://www.google.com/maps?q=${encodeURIComponent(
                    document?.indirizzo
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googlemaps}
                    alt="Mappa"
                    style={{
                      width: "100%",
                      height: "100%",
                      cursor: "pointer",
                      objectFit: "cover",
                    }}
                  />
                </a>
              </Box>
              <Typography
                fontSize={isMobile ? "24px" : "28px"}
                fontWeight={500}
                variant="h5"
                fontFamily={"degular"}
              >
                {document?.prezzo} Euro
              </Typography>
            </Box>

            <MButtonModal
              planimetria={planimetria?.photos}
              videoData={video?.photos}
            />
            <Paragraph descrizione={document?.descrizione} />
            {/* Tabella delle caratteristiche dell'immobile */}
            <Box sx={{ margin: "2%" }}>
              <Typography variant="h6" gutterBottom>
                Tutti i dettagli dell'immobile
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontSize: "1.2rem" }}>
                        <strong>Caratteristica</strong>
                      </TableCell>
                      <TableCell sx={{ fontSize: "1.2rem" }}>
                        <strong>Dettaglio</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.keys(document)
                      .filter(
                        (key) => key !== "photos" && key !== "descrizione"
                      ) // Filtra "photos"
                      .sort()
                      .map((key, index) => {
                        const value = document[key];
                        const icon = getIconForKey(key);
                        const displayKey = keyMappings[key] || key; // Usa il mapping, altrimenti la chiave originale

                        return (
                          <TableRow key={index}>
                            <TableCell
                              sx={{
                                fontSize: "1.1rem",
                                display: "flex",
                                fontFamily: "degular",
                                alignItems: "center",
                                justifyItems: "center",
                                fontWeight: 600,
                              }}
                            >
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                sx={{ marginRight: "8px" }}
                              >
                                {icon}
                              </Box>
                              {capitalizeFirstLetter(displayKey)}
                            </TableCell>
                            <TableCell sx={{ fontSize: "1.1rem" }}>
                              {value}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Divider
              sx={{
                my: 3,
              }}
              width={"30%"}
              margin={"0 auto"}
            />
          </Box>
        </Box>
        <Box width={isMobile ? "100%" : "30%"}>
          <Contact isRoom appartamento={document?.titolo} />
        </Box>
      </Stack>
    </Box>
  );
};

export default RoomSingle;
